import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateDashTime',
})
export class DateDashTimePipe implements PipeTransform {
  transform(value: string): string | null {
    if (!value) return '-';

    // Parse the date assuming it's in UTC
    const [datePart, timePart] = value.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute, second] = timePart.split(':').map(Number);

    const utcDate = new Date(
      Date.UTC(year, month - 1, day, hour, minute, second)
    );
    const localDate = new Date(utcDate);

    const dayStr = String(localDate.getDate()).padStart(2, '0');
    const monthStr = String(localDate.getMonth() + 1).padStart(2, '0');
    const yearStr = localDate.getFullYear();
    const hourStr = String(localDate.getHours()).padStart(2, '0');
    const minuteStr = String(localDate.getMinutes()).padStart(2, '0');

    return `${dayStr}/${monthStr}/${yearStr}  -  ${hourStr}:${minuteStr}`;
  }
}
